import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import UploadIcon from '@mui/icons-material/Upload';
import { Button, Container, IconButton, SelectChangeEvent, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import * as DocumentHelper from '../../api/document/documentHelper';
import { route } from '../../route/Index';
import Input from '../../shared/component/Input';
import isAdmin from '../../shared/hoc/isAdmin';
import variable from '../../shared/style/variable';
import { toastAlert } from '../../shared/util';
import { EStatusCode } from '../../api/enum';
import { LoadingButton } from '@mui/lab';

interface IHelpDetailProps {}

const HelpContainer = styled(Container)`
    padding: 0;
    flex-grow: 1;
    margin-top: 2rem;
`;

const HelpDetail = (props: IHelpDetailProps) => {
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const navigate = useNavigate();

    const { t } = useTranslation();

    const [file, setFile] = React.useState<any>();
    const [isSaveLoading, setIsSaveLoading] = React.useState(false);

    const handleClickSave = async () => {
        const formData = new FormData();
        formData.append('document', file);
        setIsSaveLoading(true);
        let res = await DocumentHelper.insertDocumentAsync(formData);
        if (res.status == EStatusCode.Ok) {
            toastAlert('success', t('savedDocument'));
        }
        setIsSaveLoading(false);
    };

    const handleChangeFile = (event: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        const file = event.target.files[0];
        setFile(file);
    };

    return (
        <>
            <Stack direction={'row'} padding={'0 1rem'} alignItems={'center'}>
                <Link to={route.backoffice} style={{ textDecoration: 'none' }}>
                    <Stack alignItems={'center'} direction={'row'}>
                        <ArrowBackIosIcon style={{ fill: variable.greenLight }} />
                        <Typography variant='h6' padding={'1rem 0'} color={variable.greenLight}>
                            {t('back')}
                        </Typography>
                    </Stack>
                </Link>
                <Stack width={'100%'} textAlign={'center'}>
                    <Typography variant='h6' color={variable.greenLight}>
                        {t('addNewDocument')}
                    </Typography>
                </Stack>
            </Stack>
            <HelpContainer maxWidth='md'>
                <Stack height={'100%'} direction='column'>
                    <Stack height={'85%'}>
                        <Stack direction={'row'} spacing={2} justifyContent={'center'}>
                            <Input disabled value={file?.name ?? ''} />
                            <IconButton aria-label='add-file' onClick={() => fileInputRef.current!.click()}>
                                <UploadIcon />
                            </IconButton>
                            <input onChange={handleChangeFile} multiple={false} ref={fileInputRef} type='file' hidden />
                        </Stack>
                    </Stack>
                    <Stack alignItems='end'>
                        <Stack direction={'row'} spacing={2}>
                            <Button variant='white' onClick={() => navigate(route.backoffice)}>
                                {t('back')}
                            </Button>
                            <LoadingButton loading={isSaveLoading} style={{ overflow: 'hidden' }} variant='orange' onClick={handleClickSave}>
                                {t('save')}
                            </LoadingButton>
                        </Stack>
                    </Stack>
                </Stack>
            </HelpContainer>
        </>
    );
};

export default isAdmin(HelpDetail);
